export default "/app/themes/macleod/public/images/arrow-right.svg?460d1be21e9361966b51a0d7470b35de";